import { QuoteTermsTemplate } from "@/utils/quoteHelpers";
import {
  HESI_MONITORING_TERMS,
  HESI_SALE_TRADE_TERMS,
  HESI_WELL_TEST_AGREEMENT,
  HESI_WELL_TEST_TERMS,
  HGC_MONITORING_TERMS,
  HGC_SALE_TRADE_TERMS,
  HGC_WELL_TEST_AGREEMENT,
  HGC_WELL_TEST_TERMS,
  RISK_ASSESSMENT
} from "./quoteTermsContent";

export interface QuoteTermsValues {
  agreementDate: string;
  customerName: string;
  quoteName: string;
  consumablesPrice: string;
  monthlyFee: string;
  dailyFee: string;
}

const escapeHtml = (value: string): string =>
  value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

const renderAgreement = (html: string, values: QuoteTermsValues): string => {
  const replacements: Record<string, string> = {
    "{{AGREEMENT_DATE}}": values.agreementDate,
    "{{CUSTOMER_NAME}}": values.customerName,
    "{{QUOTE_NAME}}": values.quoteName,
    "{{CONSUMABLES_PRICE}}": values.consumablesPrice,
    "{{MONTHLY_FEE}}": values.monthlyFee,
    "{{DAILY_FEE}}": values.dailyFee
  };

  return Object.entries(replacements).reduce(
    (result, [token, value]) =>
      result.replaceAll(token, escapeHtml(value ?? "")),
    html
  );
};

export function renderQuoteTermsHtml(
  template: QuoteTermsTemplate | null,
  values: QuoteTermsValues
): string {
  switch (template) {
    case QuoteTermsTemplate.HGC_WELL_TEST:
      return (
        renderAgreement(HGC_WELL_TEST_AGREEMENT, values) +
        RISK_ASSESSMENT +
        HGC_WELL_TEST_TERMS
      );
    case QuoteTermsTemplate.HESI_WELL_TEST:
      return (
        renderAgreement(HESI_WELL_TEST_AGREEMENT, values) +
        RISK_ASSESSMENT +
        HESI_WELL_TEST_TERMS
      );
    case QuoteTermsTemplate.HGC_SALE_TRADE:
      return HGC_SALE_TRADE_TERMS;
    case QuoteTermsTemplate.HGC_MONITORING:
      return HGC_MONITORING_TERMS;
    case QuoteTermsTemplate.HESI_SALE_TRADE:
      return HESI_SALE_TRADE_TERMS;
    case QuoteTermsTemplate.HESI_MONITORING:
      return HESI_MONITORING_TERMS;
    default:
      return "";
  }
}
